<template>
  <ion-page id="mission">
    <WhiteHeader
      :back-button="!isOutsourcing"
      route-back="/planning"
      title="Détails d'une mission"
    />
    <ion-content class="ion-padding">
      <ion-refresher
        class="refresher-detail refresh-detail-transfer"
        slot="fixed"
        @ionRefresh="doRefresh($event)"
        @click="doRefresh($event)"
        ><ion-refresher-content></ion-refresher-content
      ></ion-refresher>

      <liste-rental-coupon
        v-if="hasCoupons"
        ref="listeRentalCoupon"
        :rental-coupons="missionDetail.rental_coupons"
        type-mission="transfert"
      />

      <DayPart :part="mission.day_part"></DayPart>
      <Date
        v-if="humanStart"
        :start="humanStart"
        :end="humanEnd"
        :time-slot="missionItem.time_slot"
      />
      <hr class="color-hr" />

      <Equipment
        :machine_name="mission.machine_name"
        :machine_category="mission.machine_category"
        :machine_number="mission.machine_number"
        :machine_translation="mission.machine_translation"
        :machine_poids="mission.machine_poids"
        :tools="mission.tools"
        :voiture_pilote="missionItem.voiture_pilote"
        :attachments="mission.machine_attachments"
        :mission-id="missionItem.id"
      />
      <hr class="color-hr" />
      <Transfer
        :machines="missionItem.machines"
        :machines_manual="missionItem.machines_manual"
        :tools="missionItem.tools"
        :tools_manual="missionItem.tools_manual"
      />
      <hr class="color-hr" />
      <ion-grid>
        <ion-row>
          <ion-col class="mt-15 column">
            <ion-note>Réf chantier :</ion-note>
            <ion-label v-if="missionItem.worksite_reference">{{ missionItem.worksite_reference }}</ion-label>
            <ion-label v-else class="text-red">Aucune</ion-label>
          </ion-col>
          <ion-col class="mt-15 column">
            <ion-note>N° commande :</ion-note>
            <ion-label v-if="missionItem.order_number">{{ missionItem.order_number }}</ion-label>
            <ion-label v-else class="text-red">Aucun</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>
      <hr class="color-hr" />
      <ion-label class="bold title-detail-mission"
        >Chargement<ion-badge
          v-if="
            missionItem.coupon_company &&
            missionItem.coupon_company === 'source'
          "
          color="success"
          class="ml-10"
          >Client</ion-badge
        ></ion-label
      >
      <information
        :name-company="missionItem.source"
        :manager="missionDetail.source_contact"
        :manager_phone="missionDetail.source_contact_phone"
        :worksite_city="missionItem.source_location_city"
        :worksite_name="missionItem.source_location_name"
        :worksite_address="missionItem.source_location_address"
        :worksite_coordinates="missionItem.source_coordinates"
        :instructions="missionItem.source_instructions"
        :need_signature_source="missionItem.need_signature_source"
        ref="sourceMap"
      />
      <hr class="color-hr" />
      <ion-label class="bold title-detail-mission"
        >Déchargement<ion-badge
          v-if="
            missionItem.coupon_company &&
            missionItem.coupon_company === 'target'
          "
          color="success"
          class="ml-10"
          >Client</ion-badge
        ></ion-label
      >
      <information
        :name-company="missionItem.target"
        :manager="missionDetail.target_contact"
        :manager_phone="missionDetail.target_contact_phone"
        :worksite_city="missionItem.target_location_city"
        :worksite_name="missionItem.target_location_name"
        :worksite_address="missionItem.target_location_address"
        :worksite_coordinates="missionItem.target_coordinates"
        :instructions="missionItem.target_instructions"
        :attachments="missionItem.attachments_with_categories"
        :mission-id="missionItem.id"
        ref="targetMap"
      />
      <hr class="color-hr" />

      <new-rental-coupon
        v-if="missionItem.pricing_information"
        type-mission="transfert"
        :has-coupons="hasCoupons"
        :has-questions="!isOutsourcing && mission.has_questions"
      />
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonContent,
  IonLabel,
  IonRefresher,
  IonRefresherContent,
  IonBadge,
  toastController,
  IonRow,
  IonCol,
  IonGrid,
  IonNote,
} from '@ionic/vue';
import {
  forceRefreshDetailMission,
  forceRefreshPlanning,
  getDetailMission,
  getMissionOrder,
  fetchMissionOutsourcing,
  fetchDetailMissionOutsourcing,
} from '@/services/driver/missionsOrders';
import Equipment from '@/components/driver/detailMission/Equipment';
import Information from '@/components/driver/detailMission/Information';
import Transfer from '@/components/driver/detailMission/Transfer';
import Date from '@/components/driver/detailMission/Date';
import DayPart from '@/components/driver/card/detailCardPlanning/DayPart.vue';
import ListeRentalCoupon from '@/components/driver/detailMission/ListeRentalCoupon';
import NewRentalCoupon from '@/components/driver/detailMission/NewRentalCoupon';
import WhiteHeader from '@/components/driver/header/WhiteHeader';
import HasMissionDetailMixin from '@/mixins/HasMissionDetailMixin';

export default {
  name: 'TransfertDetail',
  components: {
    WhiteHeader,
    NewRentalCoupon,
    ListeRentalCoupon,
    Date,
    DayPart,
    Transfer,
    Information,
    Equipment,
    IonPage,
    IonContent,
    IonLabel,
    IonRefresher,
    IonRefresherContent,
    IonBadge,
    IonRow,
    IonCol,
    IonGrid,
    IonNote,
  },
  mixins: [HasMissionDetailMixin],
  data() {
    return {
      mission: {},
      missionItem: {},
      missionDetail: {},
      refreshInterval: null,
    };
  },

  // Launch auto-refresh when page gets displayed
  ionViewDidEnter() {
    this.doRefresh();

    if (!this.isOutsourcing) {
      this.refreshInterval = setInterval(() => {
        this.doRefresh();
      }, 60 * 1000);
    }

    setTimeout(() => {
      this.initMaps();
    }, 0);
  },

  ionViewWillLeave() {
    if (this.$refs.sourceMap) {
      this.$refs.sourceMap.removeMap();
    }
    if (this.$refs.targetMap) {
      this.$refs.targetMap.removeMap();
    }
  },

  // Stop auto-refresh when page quits
  ionViewDidLeave() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  },

  mounted() {
    Promise.all([
      this.getMissionRequest(),
      this.getDetailMissionRequest(),
    ]).then(([mission, missionDetail]) => {
      this.afterFetches(mission, missionDetail);
    });
  },

  methods: {
    getMissionRequest() {
      if (this.isOutsourcing) {
        return fetchMissionOutsourcing(
          'transfert',
          this.$route.params.outsourcingToken,
        );
      }

      return getMissionOrder(
        this.$route.params.id,
        this.$route.params.idRide,
        'transfert',
      );
    },

    getDetailMissionRequest(forceRefresh = false) {
      if (this.isOutsourcing) {
        return fetchDetailMissionOutsourcing(
          'transfert',
          this.$route.params.outsourcingToken,
        );
      }

      if (forceRefresh) {
        return forceRefreshDetailMission(
          'transfert',
          this.$route.params.id,
          this.$route.params.idItem,
        );
      }

      return getDetailMission(
        'transfert',
        this.$route.params.id,
        this.$route.params.idItem,
      );
    },

    doRefresh(event) {
      if (!this.isOutsourcing) {
        try {
          forceRefreshPlanning();
        } catch (error) {
          console.log('[TransferDetail] Unable to force-refresh planning.');
        }

        if (!this.$route || !this.$route.params || !this.$route.params.id)
          return;
      }

      Promise.all([
        this.getMissionRequest(),
        this.getDetailMissionRequest(true),
      ])
        .then(([mission, missionDetail]) => {
          this.afterFetches(mission, missionDetail);
        })
        .catch(() => {
          console.log('Unable to force-refresh transfer detail.');
        })
        .finally(() => {
          if (event && event.target && event.target.complete) {
            event.target.complete();
          }
        });
    },

    async backPlanning() {
      const toast = await toastController.create({
        header: 'Changement',
        message: 'La mission ne vous est plus affectée',
        duration: 3000,
        color: 'success',
        position: 'top',
        cssClass: 'toast-rental-coupon',
      });
      await toast.present();

      this.$router.push('/planning');
    },

    afterFetches(mission, missionDetail) {
      if (!mission) {
        this.backPlanning();
        return;
      }

      this.mission = mission;
      this.missionDetail = missionDetail;

      for (const tiId in this.mission['transport_items']) {
        if (this.isOutsourcing) {
          // Handle both possible `outsourcingTokenKey` (id or outsourcing_token)
          const ti = this.mission['transport_items'][tiId];
          if (
            tiId === this.$route.params.outsourcingToken ||
            ti.outsourcing_token === this.$route.params.outsourcingToken
          ) {
            this.missionItem = this.mission['transport_items'][tiId];
          }
        } else {
          if (tiId === this.$route.params.idItem) {
            this.missionItem = this.mission['transport_items'][tiId];
          }
        }
      }

      // Init maps just in case
      this.$nextTick(() => {
        this.initMaps();
      });
    },

    /**
     * Using conditions to avoid this kind of error:
     * > TypeError: Cannot read properties of null (reading 'initMap')
     */
    initMaps() {
      if (this.$refs.sourceMap) {
        this.$refs.sourceMap.initMap();
      }
      if (this.$refs.targetMap) {
        this.$refs.targetMap.initMap();
      }
    },
  },
};
</script>
